import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { BRAND, POLICIES_COPY } from '@saesak/shared';
import { AppBar, Screen } from '@/components/layout';
import { Card } from '@/components/ui';

/** 약관 및 처리방침 (v1.18) — 공시 문서를 한곳에 모은다 */
export function PoliciesPage() {
  const items = [
    { to: '/terms', label: POLICIES_COPY.terms },
    { to: '/privacy', label: POLICIES_COPY.privacy },
    { to: '/pricing', label: POLICIES_COPY.pricing },
  ];

  return (
    <Screen>
      <AppBar title={POLICIES_COPY.title} back />

      <div className="flex flex-col gap-4 p-4">
        <Card className="p-0">
          {items.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="tap flex items-center justify-between border-b border-line px-4 py-3.5 last:border-b-0"
            >
              <span className="text-base">{item.label}</span>
              <ChevronRight size={18} className="text-ink-sub" />
            </Link>
          ))}
        </Card>

        <p className="text-center text-sm text-ink-sub">
          {BRAND.name} · {BRAND.description}
        </p>
      </div>
    </Screen>
  );
}
